module.exports = __webpack_public_path__ + "static/media/prolink-shinwoo-logo.bc81b75b.png";